import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import activityLogAPI from '@infrastructure/activity-log-api';
export const getActivityLogsAsync = createAsyncThunk('activityLog/getAll', async (request, { rejectWithValue }) => {
    try {
        const response = await activityLogAPI.getActivityLogs(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
